import { render } from "./MealType.vue?vue&type=template&id=7ebbe3f0"
import script from "./MealType.vue?vue&type=script&lang=js"
export * from "./MealType.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/nutristudents-k12-container/nutristudents-k12-container/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__